export type ContentState = {
  viewMode: "formatted" | "optimized";
  urlContent: string | null;
  optimizedContent: string | null;
  isLoading: boolean;
  isOptimizing: boolean;
  contentPage: number;
  isProcessing: boolean;
  processingProgress: number;
  currentPage: number | null;
  totalPages: number | null;
  totalParts: number | null;
  currentPart: number;
  hasMetadataJson: boolean;
};

export type ContentAction =
  | { type: "SET_VIEW_MODE"; payload: "formatted" | "optimized" }
  | { type: "SET_CONTENT"; payload: { urlContent: string | null } }
  | { type: "SET_OPTIMIZED_CONTENT"; payload: { optimizedContent: string | null } }
  | { type: "SET_LOADING"; payload: boolean }
  | { type: "SET_OPTIMIZING"; payload: boolean }
  | { type: "SET_CONTENT_PAGE"; payload: number }
  | {
      type: "SET_PDF_METADATA";
      payload: { totalPages?: number | null; totalParts?: number | null; hasMetadataJson: boolean };
    }
  | {
      type: "UPDATE_PDF_PROGRESS";
      payload: { isProcessing: boolean; processingProgress: number };
    }
  | { type: "SET_CURRENT_PART"; payload: number }
  | { type: "SET_CURRENT_PAGE"; payload: number | null }
  | { type: "RESET_ALL" }
  | {
      type: "RESET_ON_DOCUMENT_CHANGE";
    };

export const initialContentState: ContentState = {
  viewMode: "formatted",
  urlContent: null,
  optimizedContent: null,
  isLoading: false,
  isOptimizing: false,
  contentPage: 1,
  isProcessing: false,
  processingProgress: 0,
  currentPage: null,
  totalPages: null,
  totalParts: null,
  currentPart: 1,
  hasMetadataJson: false,
};
